import TipTapEditor from "../Common/TipTapEditor";

export default TipTapEditor;
